import type { FC } from "react";
import { useCallback } from "react";
import { createURL } from "expo-linking";
import { useQueryClient } from "@tanstack/react-query";

import { api } from "~/utils/api";
import { authClient } from "~/utils/auth";
import { FacebookIcon } from "~/component/icons/facebook-icon";
import config from "~/config";
import type {
  SocialButtonAuthParams,
  SocialButtonProps,
} from "./social-button";
import { SocialButton } from "./social-button";

export interface FacebookButtonProps extends Omit<SocialButtonProps, "Icon"> {
  authParams?: SocialButtonAuthParams;
}

export const FacebookButton: FC<FacebookButtonProps> = ({
  authParams,
  ...props
}) => {
  const apiUtils = api.useUtils();
  const queryClient = useQueryClient();

  const handlePress = useCallback(async () => {
    await authClient.signIn.social({
      provider: "facebook",
      callbackURL: createURL("auth"),
      errorCallbackURL: createURL("auth"),
      ...authParams,
    });

    queryClient.clear();
    await apiUtils.context.person.fetch();
  }, [apiUtils.context.person, authParams, queryClient]);

  if (!config.SOCIAL_PROVIDERS?.includes("facebook")) return null;

  return <SocialButton Icon={FacebookIcon} onPress={handlePress} {...props} />;
};
